module.exports = {"Name":"Name","Email":"Email","Capacity":"Capacity","RoomType":"RoomType","Subject":"Subject","autoCheckIn":"Auto Checkin","SelectAll":"Select All","Yes":"Yes","No":"No","Building":"Building","Floor":"Floor","Zone":"Zone","Facilities":"Facilities","FirstName":"First Name","LastName":"Last Name","Backend":"Backend Accessible","Department":"Department","Description":"Description","Category":"Category","Start":"Start","End":"End","NameIOT":"Name","Room":"Room","Code":"Code","stringSearch":"Search Text"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/advanceSearch/ENG.json
// module id = 1318
// module chunks = 120